export default {"src":"/_next/static/media/IR.dfa1a9db.svg","height":18,"width":18};